//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Author, Collection } from "@/models";
import SearchBox from "@/components/SearchBox.vue";
import ListItem from "@/components/ListItemFlex.vue";
import More from "@/components/More.vue";
import { mapGetters, mapActions } from "vuex";
import Market from "@/components/Market";
import XczFooter from "@/components/footer/footer.vue";
import LibraryAuthors from "@/components/LibraryAuthors.vue";
import Collections from "@/components/collection/collections.vue";

export default {
  name: "csuLibrary",
  created() {
    this.loadBanner();

    let login = parseInt(this.$route.query.login);

    if (login == 1 && !this.user) {
      this.$router.push({
        name: "logInSelection",
        query: { from: this.$route.path }
      });
      return;
    }

    this.$initWechat().then(() => {
      this.$initWechatShare({
        title: "文库· 中华诗词库",
        link: location.href,
        // image: "http://ac-9pq709je.clouddn.com/bda4f64984c2dba80105.png",
        image: "http://bigfile.xichuangzhu.com/logo.png",
        desc: "赏中华诗词，品生活之美。"
      });
    });

    if (
      this.libraryData.authors.length == 0 ||
      this.libraryData.collections.length == 0 ||
      this.libraryData.collections.length == 0
    ) {
      this.$store.dispatch("loadLibraryData");
    }
  },
  props: [],
  data() {
    return {
      keyword: "",
      dynasties: [
        "周",
        "秦",
        "汉",
        "三国",
        "晋",
        "南北朝",
        "隋",
        "唐",
        "五代十国",
        "宋",
        "金",
        "元",
        "明",
        "清"
      ]
    };
  },
  metaInfo() {
    return {
      title: "文库 · 中华诗词库",
      titleTemplate: null
    };
  },
  methods: {
    goToClassicMore: function() {
      this.$router.push({ name: "classicMore" });
    },

    goToNavAuthor: function() {
      this.$router.push({ name: "navAuthor" });
    },

    goToNavCipai: function() {
      this.$router.push({ name: "navCipai" });
    },

    goToAuthor: function(author) {
      this.$router.push({ name: "author", params: { id: author.id } });
    },

    goToCollection: function(collection) {
      this.$router.push({ name: "collection", params: { id: collection.id } });
    },

    search: function() {
      if (this.keyword == "") {
        return;
      }

      this.$router.push({ name: "search", query: { q: this.keyword } });
    },

    goToLists: function() {
      this.$router.push({ name: "lists" });
    },

    ...mapActions(["loadBanner"])
  },
  computed: {
    ...mapGetters([
      "classicCollections",
      "topicCollections",
      "tuneCollections",
      "natureCollections",
      "festivalCollections",
      "termCollections",
      "seasonCollections",
      "bookCollections",
      "bookClassicCollections",
      "user",
      "libraryData",
      "banner"
    ])
  },
  components: {
    LibraryAuthors,
    SearchBox,
    XczFooter,
    ListItem,
    More,
    Market,
    Collections
  }
};



// WEBPACK FOOTER //
// ./src/pages/layouts/csu-pages/Library.vue